import {RECEIVE_CHANGE_HISTORY} from "../actions/historyActions";

export default function (state = [], action) {
    switch (action.type) {
        case RECEIVE_CHANGE_HISTORY:
            return action.payload;
        default:
            return state;
    }
}



/** WEBPACK FOOTER **
 ** ./src/main/javascript/disclosure/recommendations/changeHistoryReducer.js
 **/